import { render, staticRenderFns } from "./integracoes.vue?vue&type=template&id=4efef2ac&scoped=true"
import script from "./integracoes.vue?vue&type=script&lang=js"
export * from "./integracoes.vue?vue&type=script&lang=js"
import style0 from "./integracoes.vue?vue&type=style&index=0&id=4efef2ac&prod&lang=css"
import style1 from "./integracoes.vue?vue&type=style&index=1&id=4efef2ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efef2ac",
  null
  
)

export default component.exports